import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationEventEndpointTaskHttpResponse {
    notificationEventEndPointId: number;
    notificationEventId: number;
    taskContent: string;
    taskLink: string;
    useDefaultTaskSettings: boolean;
    taskConnectionString: string;
    taskSqlQuery: string;
}

export class NotificationEventEndpointTask {
    constructor(
        public notificationEventEndPointId: number,
        public notificationEventId: number,
        public taskContent: string,
        public taskLink: string,
        public useDefaultTaskSettings: boolean,
        public taskConnectionString: string,
        public taskSqlQuery: string
    ) { }

    public static adapt(data: INotificationEventEndpointTaskHttpResponse) {
        return new this(
            data.notificationEventEndPointId,
            data.notificationEventId,
            data.taskContent,
            data.taskLink,
            data.useDefaultTaskSettings,
            data.taskConnectionString,
            data.taskSqlQuery
        );
    }

    public static createBlank(notificationEventId: number) {
        return new this(0, notificationEventId, '', '', true, '', '');
    }
}

export const NotificationEventEndpointTaskColumns: Readonly<EvideTableColumn[]> = [
    {
        key: 'taskContent',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Editor,
        isFormField: true,
        isFormEditableField: true,
        title: 'Content',
        displayValue: true,
        required: true,
        required_error: 'Content is Required'
    },
    {
        key: 'taskLink',
        type: EvideTableColumnType.Number,
        compType: EvideTableColumnComponent.Dropdown,
        isFormField: true,
        isFormEditableField: true,
        title: 'Click Action Url',
        hideInList: true,
        required: false,
        placeholder: 'Please Select Click Action Url',
        required_error: 'Click Action Url is Required',
        sortable: true
    },
    {
        key: 'useDefaultTaskSettings',
        type: EvideTableColumnType.Checkbox,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Use Default Task Settings',
        displayValue: true,
        required: false
    },
    {
        key: 'taskConnectionString',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Connection String',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    },
    {
        key: 'taskSqlQuery',
        type: EvideTableColumnType.String,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Sql Query',
        displayValue: true,
        required: false,
        displayDynamicInput: true
    }
];